import { render, staticRenderFns } from "./ModalAddDoctor.vue?vue&type=template&id=660b2ca0&scoped=true"
import script from "./ModalAddDoctor.vue?vue&type=script&lang=js"
export * from "./ModalAddDoctor.vue?vue&type=script&lang=js"
import style0 from "./ModalAddDoctor.vue?vue&type=style&index=0&id=660b2ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660b2ca0",
  null
  
)

export default component.exports